export const reCaptchaSiteKey = "6LdRe1IpAAAAAPMclsfhew9MwhDn1GYUoaCUtKvW";
export const appId = "";
//1440035253559031 for testing
